<template>
  <ModalBody>
    <div class="title-lists q-px-lg q-pt-lg bg-white-1 shadow3 border-radius-sm overflow-hidden">
      <AgGrid :options="options" :row-data="gridData" :context="context" @ready="agGrid = $event">
        <template #header>
          <Grid justify-content="end">
            <ShowHideCols :ag-grid="agGrid" />
          </Grid>
        </template>
      </AgGrid>
    </div>
  </ModalBody>
</template>

<script>
import * as apiTo from '@/modular-api'
import { getTaskData } from '../modals-shared'
import { options } from './options'
// Components
import AgGrid from '@/ag-grid/AgGrid'
import ShowHideCols from '@/ag-grid/components/show-hide-cols/ShowHideCols'
import ModalBody from '../components/ModalBody'

export default {
  components: {
    AgGrid,
    ModalBody,
    ShowHideCols
  },

  mixins: [options],

  props: {
    periodId: [Number, String]
  },

  data: () => ({
    agGrid: null,
    context: {},
    gridData: null
  }),

  async created() {
    this.context = { titleListsCmp: this }
    await this.getTaskData('title-lists').then(({ data }) => (this.gridData = data.result))
    this.$emit('set-loader', false)
  },

  methods: {
    getTaskData,

    getCount() {
      return this.gridData.length
    },

    dismiss(row) {
      this.$emit('set-loader', true)

      apiTo
        .DISMISS_TASK('title-lists', row.id)
        .then(() => {
          if (this.gridData.length === 1) this.$emit('make-count-0')
          else {
            const index = this.gridData.findIndex(g => g.id === row.id)
            if (~index) this.gridData.splice(index, 1)
          }
        })
        .finally(() => this.$emit('set-loader', false))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

.title-lists {
  @include table-with-no-filters;

  height: calc(100vh - 180px);
}
</style>
